// 荟聚相关函数

import { useEffect, useCallback, useRef } from 'react'
import cookie from 'react-cookies'
import fun from './common_fun'

// 访问页面事件
function open_page(obj) {
  if (!localStorage.getItem('accept_consent') || localStorage.getItem('accept_consent') !== '1') {
    return
  }

  if (window.clab_tracker && window.clab_tracker.ready) {
    window.clab_tracker.ready(function () {
      console.log('荟聚回调函数-访问', obj)
      this.push({ pageType: "web", source: "CloudLab" });
      this.track("open_page", obj);
    });
  }
}

// 防抖函数
function useDebounce(fn, delay) {
  const { current } = useRef({ fn, timer: null });
  useEffect(function () {
    current.fn = fn;
  }, [fn]);

  return useCallback(function f(...args) {
    args[0].persist() // 这里需要这样设置是因为会警告
    if (current.timer) {
      clearTimeout(current.timer);
    }
    current.timer = setTimeout(() => {
      current.fn.call(this, ...args);
    }, delay);
  })
}

// 搜索事件
function c_cloud_lab_website_search(CPUSearch, BoardSearch) {
  if (!localStorage.getItem('accept_consent') || localStorage.getItem('accept_consent') !== '1') {
    return
  }

  if (window.clab_tracker && window.clab_tracker.ready && cookie.load('login_id')) {
    let obj = {
      "identityType": "c_cloud_lab_id",
      "identityValue": cookie.load('login_id'),
      "c_CPUSearch": CPUSearch,
      "c_BoardSearch": BoardSearch,
    }

    window.clab_tracker.ready(function () {
      console.log('荟聚回调函数-搜索', obj)
      this.push({ pageType: "web", source: "CloudLab" });
      this.track("c_cloud_lab_website_search", obj);
    });
  }
}

// 登录成功事件
function c_cloud_lab_c_website_login(id) {
  if (!localStorage.getItem('accept_consent') || localStorage.getItem('accept_consent') !== '1') {
    return
  }

  if (window.clab_tracker && window.clab_tracker.ready) {
    window.clab_tracker.ready(function () {
      console.log('荟聚回调函数-登录')
      this.push({ pageType: "web", source: "CloudLab" });
      this.track("c_cloud_lab_c_website_login", {
        "identityType": "c_cloud_lab_id",
        "identityValue": id,
      });
    });
  }
}

// 评论事件
function c_cloud_lab_c_comment(c_comment, c_boardName) {
  if (!localStorage.getItem('accept_consent') || localStorage.getItem('accept_consent') !== '1') {
    return
  }

  if (window.clab_tracker && window.clab_tracker.ready) {
    let obj = {
      "identityType": "c_cloud_lab_id",
      "identityValue": cookie.load('login_id'),
      c_comment,
      c_boardName,
    }
    window.clab_tracker.ready(function () {
      console.log('荟聚回调函数-评论', obj)
      this.push({ pageType: "web", source: "CloudLab" });
      this.track("c_cloud_lab_c_comment", obj);
    });
  }
}

// 格式化北京时间
function formateBeijingTime(time_string) {
  return fun.formateTime(new Date((new Date(time_string)).getTime() - 1000 * 3600 * 8))
}

// 预定开发板事件
function c_cloud_lab_website_board_order(c_boardType, c_boardName, time) {
  if (!localStorage.getItem('accept_consent') || localStorage.getItem('accept_consent') !== '1') {
    return
  }

  if (window.clab_tracker && window.clab_tracker.ready) {
    let c_startTime = ''
    let c_endTime = ''
    function formateHours(t) {
      t = Number(t)
      return t < 10 ? ('0' + t) : t
    }

    let { start_date, order_start_h, order_start_m, order_end_h, order_end_m } = time
    if (order_start_h === '现在开始 / From Now') {
      c_startTime = fun.formateTime(new Date())
    } else {
      c_startTime = start_date + ' ' + formateHours(order_start_h) + ':' + formateHours(order_start_m) + ':00'
    }
    if (order_end_h === '当日结束 / Day Ended') {
      c_endTime = start_date + ' ' + '23:59:59'
    } else {
      c_endTime = start_date + ' ' + formateHours(order_end_h) + ':' + formateHours(order_end_m) + ':00'
    }
    let obj = {
      "identityType": "c_cloud_lab_id",
      "identityValue": cookie.load('login_id'),
      c_boardType,
      c_boardName,
      c_startTime: formateBeijingTime(c_startTime),
      c_endTime: formateBeijingTime(c_endTime),
    }

    window.clab_tracker.ready(function () {
      console.log('荟聚回调函数-预定开发板', obj)
      this.push({ pageType: "web", source: "CloudLab" });
      this.track("c_cloud_lab_website_board_order", obj);
    });
  }
}

// 调试事件
function c_cloud_lab_c_debug(c_boardType, c_boardName) {
  if (!localStorage.getItem('accept_consent') || localStorage.getItem('accept_consent') !== '1') {
    return
  }

  if (window.clab_tracker && window.clab_tracker.ready) {
    let obj = {
      "identityType": "c_cloud_lab_id",
      "identityValue": cookie.load('login_id'),
      c_boardType,
      c_boardName,
    }
    window.clab_tracker.ready(function () {
      console.log('荟聚回调函数-调试', obj)
      this.push({ pageType: "web", source: "CloudLab" });
      this.track("c_cloud_lab_c_debug", obj);
    });
  }
}

// 更新个人信息事件
function c_cloud_lab_c_update_info(c_new_company, c_new_mobile, c_new_job_title) {
  if (!localStorage.getItem('accept_consent') || localStorage.getItem('accept_consent') !== '1') {
    return
  }

  if (window.clab_tracker && window.clab_tracker.ready) {
    let obj = {
      "identityType": "c_cloud_lab_id",
      "identityValue": cookie.load('login_id'),
      c_new_company,
      c_new_mobile,
      c_new_job_title,
    }
    window.clab_tracker.ready(function () {
      console.log('荟聚回调函数-更新个人信息', obj)
      this.push({ pageType: "web", source: "CloudLab" });
      this.track("c_cloud_lab_c_update_info", obj);
    });
  }
}

export default {
  open_page,
  c_cloud_lab_website_search,
  useDebounce,
  c_cloud_lab_c_website_login,
  c_cloud_lab_c_comment,
  c_cloud_lab_website_board_order,
  c_cloud_lab_c_debug,
  c_cloud_lab_c_update_info,
}